export default "__VITE_ASSET__BM0w5E6X__"